import gql from 'graphql-tag'

const getAllStates = (schema) => gql`
  query getAllStates {
    pdt_state(order_by: {description: asc}) {
      code
      countrycode
      description
    }
  }
`

export default getAllStates
